<template>
  <section
    v-if="preparedBanners.length"
    class="lpu-banners"
    :class="{ 'mx-n2': isMobile }"
    data-qa="branding_banners_section"
  >
    <CoreSwiper
      v-if="isMobile"
      class="px-2"
      :slides-per-view="1"
      :has-pagination="preparedBanners.length > 1"
      :placeholder-min-height="bannerPlaceholderHeight"
    >
      <template #slides="{ slideAttrs }">
        <div
          v-for="(banner, index) in preparedBanners"
          :key="index"
          v-bind="slideAttrs"
        >
          <BannerItem
            :src="banner.mobileSrc"
          />
        </div>
      </template>
    </CoreSwiper>
    <div
      v-else
      class="lpu-banners__list ga-4"
    >
      <BannerItem
        v-for="(banner, index) in preparedBanners"
        :key="index"
        :src="banner.desktopSrc"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'
import type { LpuBrandingBanner } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import BannerItem from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuBanners/components/BannerItem.vue'

const props = defineProps<{
  banners: LpuBrandingBanner[]
}>()

const isMobile = useIsMobile()

const preparedBanners = computed(() => props.banners
  .map(banner => {
    const desktopSrc = banner.desktop_image?.url
    const mobileSrc = banner.mobile_image?.url || desktopSrc

    return {
      mobileSrc,
      desktopSrc,
    }
  })
  .filter(banner => Boolean(banner.mobileSrc || banner.desktopSrc)))

/** ~350×240 slide + пагинация (mt-4 + bullets 8px) при нескольких баннерах. */
const bannerPlaceholderHeight = computed(() => (
  preparedBanners.value.length > 1 ? 260 : 236
))
</script>

<style scoped lang="scss">
@import 'www/themes/doctors/common/variables';

.lpu-banners {
  &__list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  :deep(.swiper-container > .swiper-pagination-bullets > .swiper-pagination-bullet-active) {
    background-color: var(--lpu-branding-color-primary, $ui-kit-primary);
  }
}
</style>
